// extracted by mini-css-extract-plugin
module.exports = {"btn-container":"styles_btn-container__mKBeo","slot-adv":"styles_slot-adv__9ojh7"};